import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { ORDER_CART_ENTRY_ID, ORDER_CART_TEST_ID } from '../constants';
import {
    CellIcon,
    CellPrice,
    CellTerm,
    CellTitle,
    GiftBadge,
    PromotionEntryListItem,
    Separator,
} from './entries.styles';

type PromotionEntryProps = {
    name: string;
};

export const PromotionEntry: FC<PromotionEntryProps> = ({ name }) => {
    const { t } = useTranslations();

    return (
        <PromotionEntryListItem data-test={ORDER_CART_ENTRY_ID.PROMOTION} aria-label={name}>
            <CellIcon icon="present" />
            <CellTitle data-test={ORDER_CART_TEST_ID.ENTRY_TITLE_PROMOTION}>{name}</CellTitle>
            <GiftBadge>{t['order_cart.entry_promotion.badge']}</GiftBadge>
            <Separator />
            <CellTerm>{t['order_cart.entry_promotion.price_label']}</CellTerm>
            <CellPrice
                price={{
                    formattedValue: t['order_cart.entry_promotion.price'],
                    value: 0 /* as it's a hardcoded price, the number value is not important */,
                }}
                dataTest={ORDER_CART_TEST_ID.PRICE_PROMOTION}
            />
        </PromotionEntryListItem>
    );
};
